import { Currency } from '../../../../../../common/types/Currency';

export enum FilterFieldsKeys {
  settlementDateFrom = 'settlementDateFrom',
  settlementDateTo = 'settlementDateTo',
  distributorAgentId = 'distributorAgentId',
  programName = 'programName',
  pfhNo = 'pfhNo',
  currency = 'currency',
}

export interface FilterFields {
  [FilterFieldsKeys.settlementDateFrom]: string;
  [FilterFieldsKeys.settlementDateTo]: string;
  [FilterFieldsKeys.distributorAgentId]: string;
  [FilterFieldsKeys.programName]: string;
  [FilterFieldsKeys.pfhNo]: string;
  [FilterFieldsKeys.currency]: string;
}
